import {HRadioOption} from "@components/headlessui/HRadio"
import {Option} from "@components/form"
import {TGameModes} from "@backend/types"

export type AccessOptionKeys = "public" | "privateToUsers" | "privateToGroups" | "private"

type AccessOptionType = Record<AccessOptionKeys, HRadioOption>

export const accessOptions: AccessOptionType = {
    public: {
        title: "Public access",
        description: "This game would be available to any users",
        value: "public"
    },
    privateToUsers: {
        title: "Private to users",
        description: "Only users added to this game would be able to access",
        value: "privateToUsers",
    },
    privateToGroups: {
        title: "Private to groups",
        description: "Only users of groups added to this game would be able to access",
        value: "privateToGroups"
    },
    private: {
        title: "Private to you",
        description: "You are the only one able to access this game",
        value: "private"
    }
}

type GameModeValueType = {
    title: string
    short?: string
    description: string
    example?: string
    value: TGameModes
    disabled?: boolean
    optionsFn?: () => Option[]
    options?: Option[]
}

export type GameModeOptionType = {
    [K in TGameModes]: GameModeValueType
}

export const gameModeOptions: GameModeOptionType = {
    basic: {
        title: "Basic: 1 Field",
        short: "Basic",
        description: "Basic Game with just 1 block of text",
        example: "Do you see a legal issue around {Label} in this post? Check all that apply, if any.",
        value: "basic",
        options: [
            {
                label: "Text Column",
                value: "field1"
            }]
    },
    compare: {
        title: "Compare: 2 - 4 Fields Type",
        short: "Compare",
        description: "Compare multiple sentences for accuracy",
        example: "Is this response accurate?",
        value: "compare",
        optionsFn: () => Array.from({length: 4}, (_, i) => ({
            label: `Text Column ${i + 1}`,
            value: `field${i + 1}`
        }))
    },
    battle: {
        title: "Battle Mode",
        short: "Battle",
        description: "Battle mode",
        value: "battle",
        optionsFn: () => [
            {
                label: "Input",
                value: "input"
            },
            ...Array.from({length: 8}, (_, i) => ({
                    label: `Output ${i + 1}`,
                    value: `output${i + 1}`
                }
            ))],
    },
    // childCheck: {
    //     title: "Child Check",
    //     description: "This game would be available to any users",
    //     example: "Load child labels if user accepts",
    //     disabled: true,
    //     value: "childCheck"
    // }
}


